import { render, staticRenderFns } from "./allCompanies.vue?vue&type=template&id=5366f7ed&scoped=true"
import script from "./allCompanies.vue?vue&type=script&lang=js"
export * from "./allCompanies.vue?vue&type=script&lang=js"
import style0 from "./allCompanies.vue?vue&type=style&index=0&id=5366f7ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5366f7ed",
  null
  
)

export default component.exports